import Dropzone from "dropzone";
import { DirectUpload } from "@rails/activestorage";
import { DirectUploadController } from './direct_upload';

export const overrideDropzoneCancel = function() {
  Dropzone.prototype.cancelUpload = function (file) {
    if (file.status === Dropzone.UPLOADING) {
      this.emit("canceled", file);
    } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
      file.status = Dropzone.CANCELED;
      this.emit("canceled", file);

      if (this.options.uploadMultiple) {
        this.emit("canceledmultiple", [file]);
      }
    }

    if (this.options.autoProcessQueue) {
      return this.processQueue();
    }
  };
}

export const createDropZone = function(controller) {
  return new Dropzone(controller.element, {
    url: controller.url,
    maxFiles: controller.maxFiles,
    maxFilesize: controller.maxFileSize,
    acceptedFiles: controller.acceptedFiles,
    addRemoveLinks: controller.addRemoveLinks,
    autoQueue: false,
    queuecomplete: function() {
      $('.bulk-save-btn').prop('disabled', false)
    }
  });
}

export const createDirectUploadController = function(source, file, inputName) {
  return new DirectUploadController(source, file, inputName);
}

export const createDirectUpload = function(file, url, controller) {
  return new DirectUpload(new File([file], `${file.name}`, { type: file.type }), url, controller);
}

export const findElement = function(root, selector) {
  if (typeof root == "string") {
    selector = root;
    root = document;
  }
  return root.querySelector(selector);
}

export const removeElement = function(el) {
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

export const insertAfter = function(el, referenceNode) {
  return referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}

export const removeBlob = function(id) {
  if(id) {
    $.ajax({url: `/llamavisor/destroy_blob/${id}`, method: 'DELETE'});
  }
}
